import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';

const GET_CHANGE_PROPOSAL = graphql(`
  query GetChangeProposal($id: ID!) {
    changeProposal(id: $id) {
      id
      paymentSchedule {
        stages {
          stage {
            description
            percentageDue
            isDeposit
          }
          stageValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoice {
            id
            isDepositInvoice
            totalValue {
              value
            }
          }
          invoiceValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoiceProjectPercentage
        }
        explainer
        isInSync
      }
    }
  }
`);

const useGetChangeProposal = (changeProposalId?: string) => {
  return useQuery({
    enabled: !!changeProposalId,
    queryKey: proposalKeys.changeProposal(changeProposalId!),
    queryFn: () => {
      return gqlClient.request(GET_CHANGE_PROPOSAL, {
        id: changeProposalId!,
      });
    },
  });
};

export default useGetChangeProposal;
